// Provide on a page's root component to name the CSV files its chart cards download
export abstract class ChartCsvNamer {
  abstract csvFileName ( name : string ) : string;
}
